export const modifySelectedCompanies = (selectedCompanies: string[]) => {
  const uidList: string[] = [];
  selectedCompanies.forEach((id) => {
    uidList.push('uid:' + id);
  });
  return uidList;
};
